import React from 'react';
import ViewReverse from './ViewReverse';
import Text from './Text';

const CustomTabs = ({ selectedTab, data, onPress, isBottomBorder = true }) => {
    return (
        <div className='w-full'>
            <ViewReverse className={`w-full overflow-x-auto`}>
                {data?.map((item) => (
                    <div
                        className={`py-3 px-5 border-2 z-10 rounded-tr cursor-pointer rounded-tl ${
                            selectedTab?.id == item?.id ? 'border-grey bg-white' : 'border-transparent'
                        } border-b-0`}
                        onClick={() => onPress(item)}
                    >
                        <Text
                            text={item?.name}
                            color={selectedTab?.id == item?.id ? 'text-primary' : 'text-dark-grey'}
                        />
                    </div>
                ))}
            </ViewReverse>
            {isBottomBorder && <div className='h-[2px] bg-grey w-full -mt-[2px]' />}
        </div>
    );
};

export default CustomTabs;
